import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import CashLoanPaymentLayer from "../../../components/Admin/CashLoanPaymentLayer";

const CashLoanPayment = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <CashLoanPaymentLayer />
      </MasterLayout>
    </>
  );
};

export default CashLoanPayment;
